import { QuestionsState, QuestionsAction } from "../types/context";
import {
  createContext,
  ReactNode,
  useContext,
  useReducer,
  useRef,
} from "react";

const initialState: QuestionsState = {
  answers: {
    gender: "",
    dob: "",
    weight: "",
    height: "",
    ideal_weight_kg: "",
    training_goal: "",
    body_shape: "",
    issues: [],
    focus_area: [],
    level: "",
    favorite_sport: [],
    location: "",
    has_cardio: null,
    tools: [],
    times: "",
    days_per_week: "",
    duration: "",
    referral: "",
  },
  section: 1,
  step: 1,
  questionNumbersSection1: [1, 2, 3, 4, 5],
  questionNumbersSection2: [1, 2, 3, 4],
  questionNumbersSection3: [1, 2, 3, 4],
  progress1: 1,
  progress2: 0,
  progress3: 0,
};

function reducer(
  state: QuestionsState,
  action: QuestionsAction
): QuestionsState {
  switch (action.type) {
    case "SET_ANSWER":
      return {
        ...state,
        answers: {
          ...state.answers,
          [action.payload.field]: action.payload.value,
        },
      };
    case "INCREASE_STEP":
      return {
        ...state,
        step: state.step + 1,
      };
    case "DECREASE_STEP":
      return {
        ...state,
        step: state.step - 1,
      };
    case "INCREASE_TWOSTEP":
      return {
        ...state,
        step: state.step + 2,
      };
    case "DECREASE_TWOSTEP":
      return {
        ...state,
        step: state.step - 2,
      };
    case "INCREASE_SECTION":
      return {
        ...state,
        section: state.section + 1,
      };
    case "DECREASE_SECTION":
      return {
        ...state,
        section: state.section - 1,
      };
    case "INCREASE_PROGRESS1":
      return {
        ...state,
        progress1: state.progress1 + 1,
      };
    case "DECREASE_PROGRESS1":
      return {
        ...state,
        progress1: state.progress1 - 1,
      };
    case "INCREASE_PROGRESS2":
      return {
        ...state,
        progress2: state.progress2 + 1,
      };
    case "DECREASE_PROGRESS2":
      return {
        ...state,
        progress2: state.progress2 - 1,
      };
    case "INCREASE_PROGRESS3":
      return {
        ...state,
        progress3: state.progress3 + 1,
      };
    case "DECREASE_PROGRESS3":
      return {
        ...state,
        progress3: state.progress3 - 1,
      };
    default:
      return state;
  }
}

interface QuestionsContextProps extends QuestionsState {
  dispatch: React.Dispatch<QuestionsAction>;
  answerBoxRef: React.RefObject<HTMLDivElement>;
}

const QuestionsContext = createContext<QuestionsContextProps | undefined>(
  undefined
);

const QuestionsProvider = ({ children }: { children: ReactNode }) => {
  const [
    {
      answers,
      section,
      step,
      questionNumbersSection1,
      questionNumbersSection2,
      questionNumbersSection3,
      progress1,
      progress2,
      progress3,
    },
    dispatch,
  ] = useReducer(reducer, initialState);

  const answerBoxRef = useRef<HTMLDivElement>(null);

  return (
    <QuestionsContext.Provider
      value={{
        answers,
        section,
        step,
        questionNumbersSection1,
        questionNumbersSection2,
        questionNumbersSection3,
        progress1,
        progress2,
        progress3,
        dispatch,
        answerBoxRef,
      }}
    >
      {children}
    </QuestionsContext.Provider>
  );
};

function useQuestions() {
  const context = useContext(QuestionsContext);
  if (context === undefined)
    throw new Error("QuestionsContext was used outside the QuestionsProvider");
  return context;
}

export { QuestionsProvider, useQuestions };
